import React, { useMemo, useState } from 'react';
import { faqs } from '../data/faq';
import '../styles/Faq.css';
import '../styles/Contact.css';
import Breadcrumbs from '../components/Breadcrumbs';
import FabHelp from '../components/FabHelp';
import '../styles/Breadcrumbs.css';

const PAGE_SIZE = 6;

const FaqItem = ({ q, isOpen, onToggle }) => {
  const wrapperRef = React.useRef(null);
  const [maxHeight, setMaxHeight] = React.useState('0px');

  React.useEffect(() => {
    const el = wrapperRef.current;
    if (!el) return;
    if (isOpen) {
      setMaxHeight(el.scrollHeight + 'px');
    } else {
      setMaxHeight('0px');
    }
  }, [isOpen, q.answer]);

  return (
    <div className={`faq-item ${isOpen ? 'open' : ''}`}>
      <button className="faq-question" onClick={onToggle} aria-expanded={isOpen}>
        <span className="caret" aria-hidden></span>
        {q.question}
      </button>
      <div
        ref={wrapperRef}
        className={`faq-answer-wrapper ${isOpen ? 'open' : ''}`}
        aria-hidden={!isOpen}
        style={{ maxHeight }}
      >
        <div className="faq-answer">
          <p>{q.answer}</p>
        </div>
      </div>
    </div>
  );
};

const FaqPage = () => {
  const [page, setPage] = useState(1);
  const [openId, setOpenId] = useState(null);
  const [isImageOpen, setIsImageOpen] = useState(false);

  const onFabClick = () => {
    const target = document.querySelector('.faq-partners-section');
    if (!target) return;
    const rect = target.getBoundingClientRect();
    const current = window.pageYOffset || document.documentElement.scrollTop || 0;
    window.scrollTo(0, current + rect.top);
  };

  const totalPages = Math.max(1, Math.ceil(faqs.length / PAGE_SIZE));
  const pageFaqs = useMemo(() => {
    const start = (page - 1) * PAGE_SIZE;
    return faqs.slice(start, start + PAGE_SIZE);
  }, [page]);

  const go = (p) => setPage(Math.min(totalPages, Math.max(1, p)));

  return (
    <>
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Faq' }]} />
      <section className="faq-section">
        <div className="faq-container">
          <h1 className="faq-title">Frequently Asked Questions</h1>
        <div className="faq-list">
          {pageFaqs.map((q) => (
            <FaqItem
              key={q.id}
              q={q}
              isOpen={openId === q.id}
              onToggle={() => setOpenId(openId === q.id ? null : q.id)}
            />
          ))}
        </div>

        <div className="faq-pagination" role="navigation" aria-label="FAQ pages">
          <button className="page-btn" disabled={page === 1} onClick={() => go(page - 1)}>« Prev</button>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
            <button
              key={p}
              className={`page-num ${p === page ? 'active' : ''}`}
              onClick={() => go(p)}
            >
              {p}
            </button>
          ))}
          <button className="page-btn" disabled={page === totalPages} onClick={() => go(page + 1)}>Next »</button>
        </div>
        </div>
      </section>

      <section className="faq-partners-section">
        <div className="faq-partners-container">
          <div className="fp-left">
            <h2 className="fp-title">Our Regional Partners</h2>
            <p className="fp-lead">
              Industry Max has multiple regional partners with locations in the UK, China, Canada, USA, Germany, and Spain. We work with certified distributors and service providers to deliver reliable solutions and responsive support wherever your projects are located.
            </p>
          </div>
          <div className="fp-right">
            <div className="fp-map">
              <img 
                src={require('../assets/partner_location.png')} 
                alt="Partner locations map" 
                onClick={() => setIsImageOpen(true)}
                role="button"
                aria-label="Open full-size partner locations map"
              />
              <p className="fp-caption">Partners Location Map</p>
            </div>
          </div>
          {isImageOpen && (
            <div 
              className="fp-lightbox" 
              role="dialog" 
              aria-modal="true" 
              aria-label="Full-size partner locations map"
              onClick={() => setIsImageOpen(false)}
            >
              <img src={require('../assets/partner_location.png')} alt="Partner locations map full size" />
            </div>
          )}
        </div>
      </section>

      <FabHelp 
        onClick={onFabClick}
        title="See partners"
        ariaLabel="Scroll to partners section"
      />
    </>
  );
};

export default FaqPage;
